import {Injectable} from '@angular/core';

export interface PriceSummaryGroup {
	level1: string | string[]
	level2: string | undefined
	orderId: string
}

@Injectable({
	providedIn: 'root'
})
export class PriceSummaryLocalStorageService {

	private readonly COMPONENT_NAME = 'PriceSummaryLocalStorageService';
	private readonly groupKey = 'persistentGroupSnapshot';

	constructor() {
	}

	saveSnapshot(priceSummaryGroup: PriceSummaryGroup) {
		let savedGroup = localStorage.getItem(this.groupKey);
		if (savedGroup) {
			let parsedSavedGroup = JSON.parse(savedGroup);
			parsedSavedGroup[priceSummaryGroup.orderId] = priceSummaryGroup
			localStorage.setItem(this.groupKey, JSON.stringify(parsedSavedGroup))
		} else {
			let groupObj: any = {}
			groupObj[priceSummaryGroup.orderId] = priceSummaryGroup
			localStorage.setItem(this.groupKey, JSON.stringify(groupObj))
		}
	}

	loadGroup(orderId: string): PriceSummaryGroup | undefined {
		let savedGroup = localStorage.getItem(this.groupKey)
		if (!savedGroup) return undefined

		const parsedSavedGroup = JSON.parse(savedGroup);
		return parsedSavedGroup[orderId];
	}

}
